export const THB = 'THB';
export const HKD = 'HKD';
export const SGD = 'SGD';
export const MYR = 'MYR';
export const TWD = 'TWD';
export const VND = 'VND';



// WEBPACK FOOTER //
// ./app/constants/currency.js